/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';
import {Flex, FlexBlock, FlexItem, SelectControl} from "@wordpress/components";
import { useState } from '@wordpress/element';
import Form from 'react-bootstrap/Form';
/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit({attributes, setAttributes}) {
	// const [type, setType] = useState(attributes.type)
	return (
		<div { ...useBlockProps() } >
			<Flex>
				<FlexItem>
					<img src="https://siku.org/img/splash/Logos/SIKU Logos/SIKU-icon.svg" alt="BigCo Inc. logo" />
				</FlexItem>
				<FlexBlock>
					<h5>SIKU api plugin</h5>
				</FlexBlock>
			</Flex>
			<SelectControl
				className={"data-type"}
				label={ __( 'Select a type:' ) }
				value={ attributes.type } // e.g: value = [ 'a', 'c' ]
				onChange={ ( type ) => { setAttributes({type: type} ) } }
				options={ [
					{ label: 'News', value: "news"},
					{ label: 'Documents', value: "documents"},
					{ label: 'Organizations', value: "organizations" },
					{ label: 'Projects', value: "projects"}
				] }
			/>
		</div>
	);
}

